import { FormControl, FormField, FormItem, FormLabel } from "../ui/form";
import StarIcon from "../../assets/svgs/common/star.svg";
import type { FieldValues, Path, UseFormReturn } from "react-hook-form";
import { Textarea } from "../ui/textarea";
import type { ChangeEvent } from "react";

type FormTextAreaProps<T extends FieldValues> = {
  form: UseFormReturn<T>;
  name: Path<T>;
  label?: string;
  placeholder: string;
  required?: boolean;
  onChange?: (e: ChangeEvent<HTMLTextAreaElement>) => void; // Expecting the event here
};

export const FormTextArea = <T extends FieldValues>({
  form,
  name,
  label,
  placeholder,
  required,
  onChange,
}: FormTextAreaProps<T>) => {
  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormLabel className="flex items-center gap-1 font-semibold">
            {label} {required && <StarIcon />}
          </FormLabel>
          <FormControl>
            <Textarea
              className="px-6 pt-6 border border-border rounded-xl h-40 md:h-52 font-semibold placeholder:text-secondary resize-none"
              placeholder={placeholder}
              required={required}
              {...field}
              onChange={(e) => {
                field.onChange(e); // Keep the form field in sync
                onChange?.(e); // Call the custom onChange handler with the event
              }}
            />
          </FormControl>
        </FormItem>
      )}
    />
  );
};
